import axios from "axios";
import config from "../../config";
import {
  AddWatchListEntityRequest,
  EntityTypesModel,
  WatchListDataModel,
  WatchListDeleteRequest,
  WatchListSearchModel,
  WatchListSearchRequest,
  WatchListTypeModel,
} from "./types";

const apiUrl = config.api;

const getWatchListTypes = async (): Promise<WatchListTypeModel> => {
  const response = await axios.get<WatchListTypeModel>(
    `${apiUrl}/watchlist/types`,
  );

  return response.data;
};

const getEntityTypes = async (): Promise<EntityTypesModel> => {
  const response = await axios.get<EntityTypesModel>(
    `${apiUrl}/entity-types/watchlist`,
  );

  return response.data;
};

const getWatchListData = async (
  id: string | undefined,
): Promise<WatchListDataModel> => {
  const response = await axios.get<WatchListDataModel>(
    `${apiUrl}/watchlist/${id}`,
  );

  return response.data;
};

const getWatchListSearchResults = async (
  searchRequestData: WatchListSearchRequest,
): Promise<WatchListSearchModel> => {
  const response = await axios.post<WatchListSearchModel>(
    `${apiUrl}/watchlist/search`,
    searchRequestData,
  );

  return response.data;
};

const addEntityToWatchList = async (
  watchListEntity: AddWatchListEntityRequest,
): Promise<WatchListSearchModel> => {
  const response = await axios.post<WatchListSearchModel>(
    `${apiUrl}/watchlist`,
    watchListEntity,
  );

  return response.data;
};

const deleteFromWatchList = async (
  watchListEntity: WatchListDeleteRequest,
): Promise<WatchListSearchModel> => {
  const response = await axios.delete<WatchListSearchModel>(
    `${apiUrl}/watchlist/${watchListEntity.id}`,
    { data: watchListEntity },
  );

  return response.data;
};

export {
  getWatchListTypes,
  getWatchListData,
  getEntityTypes,
  getWatchListSearchResults,
  addEntityToWatchList,
  deleteFromWatchList,
};
